import { useTranslation } from "react-i18next";
import { calculateCourseScore } from "src/helpers/calculateExamScore";
import isMobile from "src/helpers/isMobile";

import CourseProgress from "../Progresses/CourseProgress";
import DefaultDetails, { DefaultScore } from "./DefaultDetails";

export default function CourseDetails({ row, className }) {
	const { t } = useTranslation();
	const score = calculateCourseScore(row) || 0;
	const title = isMobile()
		? t("defaultsText.score")
		: t("defaultsText.yoursScore");

	return (
		<DefaultDetails
			className={className}
			row={row}
			title={row.name}
			Score={() => <DefaultScore title={`${title}: ${score}%`} />}
			Progress={() => <CourseProgress row={row} />}
		/>
	);
}
